import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

const CardName = ({ name, className, paddingRight, children }) => {
  return (
    <div className={`xlate-none ${styles.name} ${className}`} itemProp="name" title={name} style={{ paddingRight }}>
      {children || name}
    </div>
  );
};

CardName.defaultProps = {
  className: '',
  paddingRight: 0,
  children: null
};

CardName.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  paddingRight: PropTypes.number,
  children: PropTypes.node
};

export default CardName;
